import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiButton } from 'shell/components/shared/button';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { ResearchMetricFilterVM, ResearchMetricVM } from 'practice/view-models/research-metric';
import ListTypeRegister from 'practice/components/shared/list-type-register';
import ListTypePractice from 'practice/components/shared/list-type-practice';
import ListTypeOperation from '../../shared/list-type-operation';
import StateList from 'practice/components/shared/state-list';
import { DatePicker } from '@mui/lab';

const FormFilter = (): React.ReactElement => {
  const formContext = useFormikContext<ResearchMetricVM>();

  const onChange = useEventCallback(
    (
      key: keyof ResearchMetricFilterVM,
      value: ResearchMetricFilterVM[keyof ResearchMetricFilterVM]
    ) => {
      formContext.setFieldValue('filter', {
        ...(formContext.values?.filter || {}),
        [key]: value,
      });
    }
  );

  const handleListTypeRegisterChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typeRegister', event.target.value);
  });

  const handleListTypePracticeChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typePractice', event.target.value);
  });

  const handleListTypeOperationChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typeOperation', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <ListTypeRegister
          value={formContext.values?.filter?.typeRegister || ''}
          onChange={handleListTypeRegisterChange}
          error={
            (formContext.touched.filter as FormikTouched<ResearchMetricFilterVM>)?.typeRegister &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchMetricFilterVM>)?.typeRegister
            )
          }
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <ListTypePractice
          value={formContext.values?.filter?.typePractice || ''}
          onChange={handleListTypePracticeChange}
          error={
            (formContext.touched.filter as FormikTouched<ResearchMetricFilterVM>)?.typePractice &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchMetricFilterVM>)?.typePractice
            )
          }
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <ListTypeOperation
          value={formContext.values?.filter?.typeOperation || ''}
          onChange={handleListTypeOperationChange}
          error={
            (formContext.touched.filter as FormikTouched<ResearchMetricFilterVM>)?.typeOperation &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchMetricFilterVM>)?.typeOperation
            )
          }
          disabled={!Boolean(formContext.values?.filter?.typePractice)}
          tyPractice={formContext.values?.filter?.typePractice || ''}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <StateList
          label="Stato pratica"
          value={formContext.values?.filter?.state || ''}
          onChange={(value) => onChange('state', value)}
          error={
            (formContext.touched.filter as FormikTouched<ResearchMetricFilterVM>)?.state &&
            Boolean((formContext.errors.filter as FormikErrors<ResearchMetricFilterVM>)?.state)
          }
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Periodo di attivazione della metrica Dal"
          aria-label="Periodo di attivazione della metrica Dal"
          value={formContext.values?.filter?.dateFrom || null}
          onChange={(value) => onChange('dateFrom', value)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateFrom"
              helperText={
                (formContext.errors.filter as FormikErrors<ResearchMetricFilterVM>)?.dateFrom
              }
              error={
                (formContext.touched.filter as FormikTouched<ResearchMetricFilterVM>)?.dateFrom &&
                Boolean(
                  (formContext.errors.filter as FormikErrors<ResearchMetricFilterVM>)?.dateFrom
                )
              }
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Periodo di attivazione della metrica Al"
          aria-label="Periodo di attivazione della metrica Al"
          value={formContext.values?.filter?.dateTo || null}
          onChange={(value) => onChange('dateTo', value)}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateTo"
              helperText={
                (formContext.errors.filter as FormikErrors<ResearchMetricFilterVM>)?.dateTo
              }
              error={
                (formContext.touched.filter as FormikTouched<ResearchMetricFilterVM>)?.dateTo &&
                Boolean((formContext.errors.filter as FormikErrors<ResearchMetricFilterVM>)?.dateTo)
              }
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
        <Grid item xs={12} md={2}>
          <PmiButton variant="contained" color="secondary" fullWidth type="submit">
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Form Filter';

export default FormFilter;
